import {Subscription} from '@common/billing/subscription';
import {Product} from '@common/billing/product';

export function getActiveSubscription(
  subscriptions: Subscription[] | undefined,
): Subscription | undefined {
  return subscriptions?.find(sub => sub.valid);
}

export function getLatestSubscriptionForProduct(
  subscriptions: Subscription[] | undefined,
  productId: number,
): Subscription | undefined {
  const matches = (subscriptions ?? [])
    .filter(sub => sub.product_id === productId)
    .sort((a, b) => b.id - a.id);

  return matches[0];
}

export function getSubscriptionPeriodEndDate(
  subscription: Subscription | undefined,
): string | undefined {
  if (!subscription) {
    return undefined;
  }

  if (subscription.on_trial && subscription.trial_ends_at) {
    return subscription.trial_ends_at;
  }

  if (subscription.ends_at) {
    return subscription.ends_at;
  }

  return subscription.renews_at || undefined;
}

function resolveCurrentProduct(
  subscription: Subscription,
  plans?: Product[],
): Product | undefined {
  if (subscription.product) {
    return subscription.product;
  }

  return plans?.find(p => p.id === subscription.product_id);
}

export function canCheckoutPlan(
  subscription: Subscription | undefined,
  plan: Product,
  plans?: Product[],
): boolean {
  if (plan.free || plan.hidden) {
    return false;
  }

  if (!subscription?.valid) {
    return true;
  }

  const currentProduct = resolveCurrentProduct(subscription, plans);

  if (!currentProduct) {
    return plan.id === subscription.product_id;
  }

  return (
    plan.position > currentProduct.position || plan.id === currentProduct.id
  );
}

export function isRenewalPlan(
  subscription: Subscription | undefined,
  plan: Product,
): boolean {
  return (
    !!subscription?.valid &&
    subscription.gateway_name !== 'none' &&
    subscription.product_id === plan.id
  );
}

export function isCurrentPlan(
  subscription: Subscription | undefined,
  plan: Product,
): boolean {
  return (
    !!subscription?.valid &&
    subscription.gateway_name !== 'none' &&
    subscription.product_id === plan.id
  );
}
